import styled from 'styled-components';

export const Root = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 15;
`;

export const Paranja = styled.div`
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
`;

export const Content = styled.div`
    position: absolute;
`;
